import Vue from "vue";
/*
 *  公用函数库
 */
export const randomNum = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + min;
}

/**
 * 日期格式化
 * @param  {[int]}  timestamp 时间戳，毫秒
 * @param  {[string]} fmt 时间格式 ，例如 y-m-d h:ii:ss
 * @return {string} 日期字符串
 */
export const formatDate = (timestamp, fmt) => {
  if (!timestamp) {
    return '';
  }
  let date = new Date(timestamp);
  // 第一步先替换年份 因为年份跟其他不一样是四位
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, date.getFullYear())
  }
  // 第二步匹配其他，然后替换
  let obj = {
    "m+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "i+": date.getMinutes(),
    "s+": date.getSeconds(),
  }
  for (let key in obj) {
    let pat = `(${key})`
    if (new RegExp(pat).test(fmt)) {
      let str = obj[key] + '';
      // RegExp.$1  mm dd hh ii ss贪婪匹配
      fmt = fmt.replace(RegExp.$1, ('00' + str).substr(-2))
    }
  }
  return fmt;
}
/**
 * 获取url参数
 */
export const getUrlParams = (url) => {
  let params = {}
  let query = url.split('?')
  if (query.length > 1) {
    let buf = query[1].split('&')
    for (let i = 0; i < buf.length; i++) {
      let tmp = buf[i].split('=')
      params[tmp[0]] = tmp[1]
    }
  }
  return params
}
export const textCopy = (text) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.$copyText(text).then(() => {
      resolve()
    }, () => {
      reject();
    })
  });

}
/**
 * 随机字符串
 * @param {*} length 
 * @returns 
 */
export const randomString = (length = 32) => {
  var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
  var result = '';
  for (var i = length; i > 0; --i)
    result += str[Math.floor(Math.random() * str.length)];
  return result;
}



//获取URL参数的值（十六进制）
export function getUrlParam(name, url = window.location.href) {
  // 通过 ? 分割获取后面的参数字符串
  let urlStr = url.split('?')[1];
  if (!urlStr) return null;
  // 创建空对象存储参数
  let obj = {};
  // 再通过 & 将每一个参数单独分割出来
  let paramsArr = urlStr.split('&')
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
    let arr = paramsArr[i].split('=')
    obj[arr[0]] = arr[1];
  }
  return obj[name]
}
